import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import stl from "./CityComponent.module.css";
import HeroArea from "./components/HereAre/HeroArea";
import BreadCrumb from "@componentsShared/BreadCrumb";
import CitiesList from "./components/CitiesList/CitiesList";
import LatestOffer from "./components/LatestOffer/LatestOffer";
import BuyItWeDeliverIt from "./components/BuyItWeDeliverIt/BuyItWeDeliverIt";
var CityComponent = function CityComponent(_ref) {
  var citiesData = _ref.citiesData;
  var _useTranslation = useTranslation(["web_city"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.C_container
  }, /*#__PURE__*/React.createElement(HeroArea, null), /*#__PURE__*/React.createElement("div", {
    className: stl.C_content
  }, /*#__PURE__*/React.createElement(BreadCrumb, {
    className: stl.brdCrmb,
    links: [{
      title: t("المدن", {
        ns: "web_common"
      })
    }]
  }), (citiesData === null || citiesData === void 0 ? void 0 : citiesData.cities) && /*#__PURE__*/React.createElement(CitiesList, {
    cities: citiesData.cities
  }), (citiesData === null || citiesData === void 0 ? void 0 : citiesData.posts) && /*#__PURE__*/React.createElement(LatestOffer, {
    posts: citiesData.posts,
    lazyOnly: true,
    hasTitle: true,
    hasArrow: true,
    lessMobDesign: true
  }), /*#__PURE__*/React.createElement(BuyItWeDeliverIt, null))));
};
export default CityComponent;